import { render } from "./CustomTagsAndFieldsRichText.vue?vue&type=template&id=cd7396e6&scoped=true"
import script from "./CustomTagsAndFieldsRichText.vue?vue&type=script&lang=js"
export * from "./CustomTagsAndFieldsRichText.vue?vue&type=script&lang=js"

import "./CustomTagsAndFieldsRichText.vue?vue&type=style&index=0&id=cd7396e6&lang=scss"
import "./CustomTagsAndFieldsRichText.vue?vue&type=style&index=1&id=cd7396e6&lang=scss&scoped=true"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-cd7396e6"]])

export default __exports__